<template>
  <div>
    <el-dialog
      title="配送区域"
      :visible.sync="AreaVisible"
      width="80%"
      append-to-body
      :before-close="handleClose"
    >
      <el-row :gutter="20">
        <el-col :span="12" v-for="(item, index) in AreaPsarea" :key="index"
          ><div class="cus_area">
            {{ index + 1 }}、{{ item.province }} / {{ item.city }} /
            {{ item.county }}
          </div></el-col
        >
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      AreaPsarea: [],
      AreaVisible: false,
    };
  },
  created() {},
  methods: {
    init(row) {
      this.$axios
        .get("/admin/entrepot/getEntrepot?id=" + row.id, {})
        .then((res) => {
          this.AreaPsarea = res.data.tentrepotAreas;
          this.AreaVisible = true;
        });
    },
    handleClose() {
      this.AreaVisible = false;
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
.cus_area {
  margin: 10px;
}
</style>
